import { cn } from '@shared/utils';
import { Thumbnail } from '@shared/ui';
import type { PhotoFile } from '@square-photo/types';

export interface PhotoGridProps {
  photos: PhotoFile[];
  showRemoveButton?: boolean;
  onRemove?: (id: string) => void;
  className?: string;
}

export function PhotoGrid({
  photos,
  showRemoveButton = false,
  onRemove,
  className,
}: PhotoGridProps) {
  if (photos.length === 0) return null;

  return (
    <div
      data-testid="photo-grid"
      className={cn(
        'grid grid-cols-3 gap-1',
        'md:grid-cols-4 md:gap-1.5',
        className,
      )}
    >
      {photos.map((photo) => (
        <div key={photo.id} data-testid="photo-item">
          <Thumbnail
            src={photo.preview}
            alt={photo.file.name}
            status={photo.status}
            onRemove={
              showRemoveButton && onRemove
                ? () => onRemove(photo.id)
                : undefined
            }
          />
        </div>
      ))}
    </div>
  );
}
